/* global Intercom */
import PropTypes from 'prop-types';
import React from 'react';
import logo from '../../assets/logo.png';
import { Button, Image, Menu, Icon } from 'semantic-ui-react';
import styles from './App.scss';
import axios from 'axios';

export default class Sidebar extends React.Component {
  static propTypes = {
    setSidebarOpenState: PropTypes.func,
    router: PropTypes.object.isRequired,
    viewer: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.transition = this.transition.bind(this);
    this.signOut = this.signOut.bind(this);
    this.getHelp = this.getHelp.bind(this);
  }

  getHelp() {
    // eslint-disable-next-line new-cap
    if (Intercom) Intercom('show');
  }

  transition(e) {
    e.preventDefault();
    this.props.router.push(e.target.getAttribute('to') || '/');
    if (this.props.setSidebarOpenState) this.props.setSidebarOpenState(false);
  }

  signOut() {
    axios.get('/users/sign_out').then(() => {
      window.location = '/';
    });
  }

  render() {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100%',
          padding: '5em 1.6em 1em 1.6em'
        }}
      >
        <div style={{ flex: 1 }}>
          <a to='/' onClick={this.transition}>
            <Image src={logo} className={styles.logo} />
          </a>
          {this.props.viewer &&
            <div>
              <Menu text vertical className={styles.sidebar}>
                <a
                  to='/'
                  className={[
                    'item',
                    location.pathname.match(/^\/$/) ? 'active' : ''
                  ].join(' ')}
                  onClick={this.transition}
                >
                  <Icon name='folder outline' />
                  &nbsp; All Events
                </a>
                <a
                  to='/calendar'
                  className={[
                    'item',
                    location.pathname.match(/^\/calendar$/) ? 'active' : ''
                  ].join(' ')}
                  onClick={this.transition}
                >
                  <Icon name='calendar alternate outline' />
                  &nbsp; Calendar
                </a>
                <a
                  to='/pipelines'
                  className={[
                    'item',
                    location.pathname.match(/^\/pipelines$/) ? 'active' : ''
                  ].join(' ')}
                  onClick={this.transition}
                >
                  <Icon name='arrow alternate circle right outline' />
                  &nbsp; Pipeline
                </a>
                <a
                  to='/financials'
                  onClick={this.transition}
                  className={[
                    'item',
                    location.pathname.match(/^\/financials(\/(.)*)?$/) ? 'active' : ''
                  ].join(' ')}
                >
                  <Icon name='dollar' />
                  &nbsp; Financials
                </a>
                <a
                  className={[
                    'item',
                    location.pathname.match(/^\/leads(\/(.)*)?$/) ? 'active' : ''
                  ].join(' ')}
                  to='/leads'
                  onClick={this.transition}
                >
                  <Icon name='code' />
                  &nbsp; Lead Capture
                </a>
                <a
                  className={[
                    'item',
                    location.pathname.match(/^\/templates(\/(.)*)?$/) ? 'active' : ''
                  ].join(' ')}
                  to='/templates'
                  onClick={this.transition}
                >
                  <Icon name='copy' />
                  &nbsp; Templates
                </a>
              </Menu>
              <Button
                primary
                content='Add Event'
                fluid
                style={{ marginTop: '2em' }}
                to='/events/new'
                onClick={this.transition}
              />
            </div>
          }
          {!this.props.viewer &&
            <Menu text vertical className={styles.sidebar}>
              <Menu.Item href='/login'>
                <Icon name='sign in' />
                &nbsp; Sign In
              </Menu.Item>
            </Menu>
          }
        </div>
        <div>
          <Menu vertical text className={styles.sidebar}>
            {this.props.viewer &&
              <div>
                <a className='item' onClick={this.getHelp}>
                  <Icon name='help circle' />
                  &nbsp; Help
                </a>
                <a className='item' to='/settings' onClick={this.transition}>
                  <Icon name='setting' />
                  &nbsp; Settings
                </a>
                <a className='item' onClick={this.signOut}>
                  <Icon name='sign out' />
                  &nbsp; Sign Out
                </a>
              </div>
            }
          </Menu>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/App/SidebarComponent.js